import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { SIZE } from '../../../../constants/size'
import Button from '../../../Button'
import { useFileUpload } from '../../../File'
import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { Content } from '../../../Modal'
import { DOC_FLOW_FORM_FIELD_FILES } from '../../DocFlow.constants'
import { DocFlowAttachFilesButton } from '../../DocFlowAttachFilesButton'

import { DocFlowFormBuildingScopeFields } from './DocFlowFormBuildingScopeFields'
import { DocFlowFormConnectedRequestsField } from './DocFlowFormConnectedRequestsField'
import { DocFlowFormFilesField } from './DocFlowFormFilesField'
import { DocFlowFormFinalDocumentTitleFields } from './DocFlowFormFinalDocumentTitleFields'
import { DocFlowFormTitleField } from './DocFlowFormTitleField'

import * as styles from './FormFields.module.css'

function FormFields({
  contentComponentProps: {
    size: contentSize = SIZE.X_LARGE,
    ...contentComponentProps
  } = EMPTY_OBJECT,
  files,
  notifications,
  setFiles,
  submitButtonText,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { dirty, isSubmitting, setFieldValue } = useFormikContext()

  const {
    filesError,
    filesUploading,
    handleExcludeFile,
    handleRemoveFile,
    handleStartUploading,
    handleUploadErrors,
    handleUploadFile,
    totalFilesCount,
  } = useFileUpload({
    files,
    onSetFiles: setFiles,
  })

  useFormValidationErrorsNotification({
    files: { filesError, filesUploading },
    onRemoveNotification,
    onSetNotification,
  })

  useEffect(() => {
    setFieldValue(DOC_FLOW_FORM_FIELD_FILES, files)
  }, [files])

  function handleCancel() {
    return onCancel({ dirty })
  }

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: null,
        ButtonClear: null,
        UploadComponent: DocFlowAttachFilesButton,
        cancelProps: {
          onClick: handleCancel,
        },
        className: styles.actions,
        isSubmitting,
        submitProps: {
          isLoading: isSubmitting,
          title: submitButtonText,
        },
        uploadProps: {
          Button: Button.Text,
          text: 'Modal.AttachBtnKey',
          totalFilesCount,
          onFinishUpload: handleUploadFile,
          onStartUpload: handleStartUploading,
          onUploadErrors: handleUploadErrors,
        },
      }}
    >
      <Content {...contentComponentProps} size={contentSize}>
        <FormInlineNotifications notifications={notifications} />
        <FormFieldsContainer className={styles.fieldsContainer}>
          <DocFlowFormTitleField />
          <DocFlowFormBuildingScopeFields />
          <DocFlowFormConnectedRequestsField />
          <DocFlowFormFinalDocumentTitleFields />
          {files.length > 0 || filesUploading.length > 0 ? (
            <DocFlowFormFilesField
              files={files}
              filesError={filesError}
              filesUploading={filesUploading}
              onExcludeFile={handleExcludeFile}
              onRemoveFile={handleRemoveFile}
            />
          ) : null}
        </FormFieldsContainer>
      </Content>
    </FormBody>
  )
}

export default FormFields
